export const cloneControl = {
  defaultButton: `Clone`,
  defaultNoun: `settings`,
  itemNounDefault: `these settings`,
  pullTitle: `Bring settings from another listing`,
  pushTitle: `Copy these settings to another listing`,
  pullSubReplace: `They'll be applied to this listing`,
  pullSubAdd: `They'll be added to this listing's`,
  pushSubReplace: `They'll be applied to the ones you choose`,
  pushSubAdd: `They'll be added to the ones you choose`,
  pullTitleFull: `Bring {noun}`,
  pushTitleFull: `Copy {noun}`,
  pullSubtitle: `Choose the listing to bring the settings from. They'll be applied to this one.`,
  pushSubtitle: `Copy these settings to the listings you choose.`,
};
